module.exports = __webpack_public_path__ + "static/img/Bradley_Hill_mobile.d0e5be0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bradley_Hill_mobile.jpg
// module id = g0w7
// module chunks = 0